import IconButton from '@mui/material/IconButton';
import { useRef } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

type TableContextMenuButtonProps = {
  onOpen: (anchorEl: HTMLElement) => void;
};

export const TableContextMenuButton = ({ onOpen }: TableContextMenuButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <IconButton
      ref={buttonRef}
      size="small"
      aria-label="Open context menu"
      aria-haspopup="menu"
      sx={{
        position: 'absolute',
        top: '1px',
        right: '0',
        transform: 'rotateZ(90deg)',
        padding: '0',
        borderRadius: '4px',
        border: '1px solid rgb(230,234,235)',
        backgroundColor: 'rgb(236,239,241)',
        '&:hover': {
          backgroundColor: 'rgb(229,230,234)',
        },
      }}
      className="py-tableContextMenuTrigger"
      onClick={(e) => {
        e.stopPropagation();
        if (buttonRef.current) onOpen(buttonRef.current);
      }}
    >
      <MoreHorizIcon fontSize="small" />
    </IconButton>
  );
};
